import React from 'react';

const Cross = ({ className }: { className?: string }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 18.243 18.243"
			className={className}
		>
			<g>
				<g
					fill="none"
					stroke="currentColor"
					strokeLinecap="round"
					strokeWidth="3"
				>
					<path d="m2.122 16.121 14-14" />
					<path d="m16.122 16.121-14-14" />
				</g>
			</g>
		</svg>
	);
};

export default Cross;
